import React, { forwardRef } from 'react'
import { useAppSelector } from '../../app/hooks'
import TimesheetSections from './TimesheetSections'

const TimesheetTableContainer = forwardRef((props, ref) => {
    const { isLoading } = useAppSelector((state) => state.timesheet);
    return (
        <div id="timesheetTable" className={"tableContainer"}>
            {!isLoading && <TimesheetSections  ref={ref}/>}
            {/* <TimesheetSections /> */}
        </div>
    )
}
)

export default TimesheetTableContainer